import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Header extends Component {
    render() {
        return (
            <header className="app-header container">
                <nav className="navbar navbar-expand-lg navbar-dark">
                    <Link className="navbar-brand" to='/'>
                        <img src="../../img/cunum.svg" width="200" height="50" alt="Cunum logo"/>
                    </Link>
                </nav>
            </header>
        );
    }
}

export default Header;
